export default "__VITE_ASSET__BBM0uNsI__"